import { useEffect } from 'react';

const CrudModal = ({ open, title, children, onClose, maxWidthClass = 'max-w-4xl' }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/55 p-4 backdrop-blur-[2px]" onClick={onClose}>
      <div
        role="dialog"
        aria-modal="true"
        className={`w-full ${maxWidthClass} max-h-[90vh] overflow-y-auto rounded-2xl border border-gray-200 bg-white shadow-2xl`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 z-10 border-b bg-gradient-to-r from-gray-50 to-white px-6 py-4">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">Cadastro</p>
              <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
            </div>
            <button type="button" className="btn-secondary !px-3 !py-1" onClick={onClose}>Fechar</button>
          </div>
        </div>
        <div className="space-y-6 p-6 md:p-7">{children}</div>
      </div>
    </div>
  );
};

export default CrudModal;
